import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "@/components/ui/button";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { Language } from "@/contexts/LanguageContext";

export const CompactLanguageToggle = () => {
  const { language, setLanguage } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="bg-background/80 backdrop-blur-sm border-primary/20 hover:bg-background/90"
        >
          <Globe className="h-4 w-4 mr-1.5" />
          {language === 'en' ? 'EN' : 'CZ'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[120px] bg-background">
        <DropdownMenuItem 
          onClick={() => setLanguage('en')}
          className="cursor-pointer"
        >
          <span className="flex items-center justify-between w-full">
            <span>English</span>
            {language === 'en' && <Check className="h-4 w-4 ml-2" />}
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setLanguage('cs')}
          className="cursor-pointer"
        >
          <span className="flex items-center justify-between w-full">
            <span>Čeština</span>
            {language === 'cs' && <Check className="h-4 w-4 ml-2" />}
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
